import React from 'react';
import * as userAccountActions from '../../actions/userAccount/userAccountActions';

const timeout = parseInt(process.env.TIME_OUT) * 60 * 1000;

export default function AutoLogout(ComposedClass) {
    class HigherOrderComponent extends React.Component {
      constructor(props) {
        super(props);
        this.state = {
          signoutTime: timeout
        };

        this.clearTimeoutFunc = this.clearTimeoutFunc.bind(this);
        this.setTimeout = this.setTimeout.bind(this);
        this.resetTimeout = this.resetTimeout.bind(this);
        this.logout = this.logout.bind(this);
        this.destroy = this.destroy.bind(this);
      }
  
      componentDidMount() {
        this.events = [
          'load',
          'mousemove',
          'mousedown',
          'click',
          'scroll',
          'keypress'
        ];
  
        for (var i in this.events) {
          window.addEventListener(this.events[i], this.resetTimeout);
        }
  
        this.setTimeout();
      }
  
      clearTimeoutFunc(){  
        if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
      }
  
      setTimeout(){
        this.logoutTimeout = setTimeout(this.logout, this.state.signoutTime);
      }
  
      resetTimeout(){
        this.clearTimeoutFunc();
        this.setTimeout();
      }
  
      logout(){
        // Send a logout request to the API
        this.destroy();
      }
  
      destroy(){
       //clear the session
        userAccountActions.logout();
        window.location.assign(process.env.BASE_URL);
      }
  
      render() {  
        return (
          <div>
            <ComposedClass {...this.props} />
          </div>
        );
      }
    }
    return HigherOrderComponent;
  }